import { render, staticRenderFns } from "./lessonstudy.vue?vue&type=template&id=3b00bead&scoped=true&"
import script from "./lessonstudy.js?vue&type=script&lang=js&"
export * from "./lessonstudy.js?vue&type=script&lang=js&"
import style0 from "./lessonstudy.vue?vue&type=style&index=0&id=3b00bead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b00bead",
  null
  
)

export default component.exports